var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"money-strategy"},[_c('div',{on:{"click":function($event){return _vm.handleNavigate('/knowledge-show')}}}),_c('div',{on:{"click":function($event){return _vm.handleNavigate(`/money`)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }